<template lang="html">

  <section class="text-legal pad-sec">
    <div class="container">

      <div class="block-legal">
        <h3 class="title title-36">{{$t('enlaces.textos.mapa_web')}} {{$t('enlaces.textos.ajusa')}}</h3>

        <ul class="list">

          <li>
            <router-link :to="$t('enlaces.productos')">{{$t('enlaces.textos.productos')}}</router-link>
          </li>

          <li>
            <router-link :to="$t('enlaces.catalogo')">{{$t('enlaces.textos.catalogo')}}</router-link>
          </li>

          <li>
            <router-link :to="$t('enlaces.area_tecnica')">{{$t('enlaces.textos.area_tecnica')}}</router-link>
          </li>

          <li>
            <router-link :to="$t('enlaces.ajusa')">{{$t('enlaces.textos.ajusa')}}</router-link>
          </li>

          <li>
            <router-link class="sub" :to="$t('enlaces.historia')">{{$t('enlaces.textos.historia')}}</router-link>
          </li>

          <li>
            <router-link :to="$t('enlaces.actualidad')">{{$t('enlaces.textos.actualidad')}}</router-link>
          </li>

          <li>
            <router-link class="sub" :to="$t('enlaces.sala_prensa')">{{$t('enlaces.textos.sala_prensa')}}</router-link>
          </li>

          <li>
            <router-link :to="$t('enlaces.contacto')">{{$t('enlaces.textos.contacto')}}</router-link>
          </li>

          <li>
            <router-link class="sub" :to="$t('enlaces.trabaja_con_nosotros')">{{$t('enlaces.textos.trabaja_con_nosotros')}}</router-link>
          </li>

          <li>
            <router-link :to="$t('enlaces.blog')">{{$t('enlaces.textos.blog')}}</router-link>
          </li>

          <li>
            <router-link :to="$t('enlaces.politica')">{{$t('enlaces.textos.politica_privacidad')}}</router-link>
          </li>

          <li>
            <router-link :to="$t('enlaces.politica_cookies')">{{$t('enlaces.textos.politica_cookies')}}</router-link>
          </li>

          <li>
            <router-link :to="$t('enlaces.aviso_legal')">{{$t('enlaces.textos.aviso_legal')}}</router-link>
          </li>

          <li>
            <router-link :to="$t('enlaces.datos_seguros')">{{$t('enlaces.textos.datos_seguros')}}</router-link>
          </li>

        </ul>
      </div>
    </div>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'mapa-web',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
  }
</script>

<style scoped>
a {
  font-family: 'Conv_Ahmet Altun - HalisGR-Regular';
  margin-bottom: 10px;
  font-size: 18px;
  width: 100%;
  display: inline-block;
}

a.sub{
  padding-left: 15px;
  font-family: 'Conv_Ahmet Altun - HalisGR-Light';
}

</style>



// WEBPACK FOOTER //
// src/components/views/mapa-web.vue